export default __webpack_public_path__ + "static/media/logo.90e53b36.png";